import { useMemo } from 'react';

export const useTagFiltering = (optionsData, selectedTheme, selectedSubTheme) => {
  const getFilteredOptions = useMemo(() => {
    return (searchValue) => {
      const searchLower = searchValue?.toLowerCase() || '';
      
      const filterItems = (items) => 
        !searchValue ? items : items.filter(item => 
          item.display?.toLowerCase().includes(searchLower)
        );

      const result = {
        themes: filterItems(optionsData.themes || []),
        // Independent sub-themes (not linked to any theme)
        subThemes: filterItems(
          (optionsData.subThemes || []).filter(item => 
            !item.tags?.themes?.data?.length
          )
        ),
        // Independent tags (not linked to any sub-theme)
        tags: filterItems(
          (optionsData.tags || []).filter(item => 
            !item.tags?.subThemes?.data?.length
          )
        )
      };

      // Add contextual options based on selections
      if (selectedTheme) {
        result.subThemesForSelectedTheme = filterItems(
          (optionsData.subThemes || []).filter(item => 
            item.tags?.themes?.data?.some(theme => theme._id === selectedTheme._id)
          )
        );
      }

      if (selectedSubTheme) {
        result.tagsForSelectedSubTheme = filterItems(
          (optionsData.tags || []).filter(item => 
            item.tags?.subThemes?.data?.some(subTheme => subTheme._id === selectedSubTheme._id)
          )
        );
      }

      return result;
    };
  }, [optionsData, selectedTheme, selectedSubTheme]);

  return { getFilteredOptions };
};
